import React from "react";
import getConfig from "next/config";
import Link from "next/link";
import Alert from "@components/Alert";
import { resizeImage } from "@lib/helpers";
import Heading from "@components/Heading";
import classNames from "classnames";

const {
  publicRuntimeConfig: {
    settings: { baseUrl, websiteName },
  },
} = getConfig();

const Subcategories = ({ subcategories }) => {
  if (subcategories && subcategories.length > 0) {
    return (
      <ul className="flex flex-wrap -mx-1 md:-mx-2 py-6">
        {subcategories.map((subcategory) => (
          <li
            className="w-1/2 md:w-1/3 lg:w-1/5 p-1 md:p-2"
            key={subcategory.id}
          >
            {subcategory.url_absolute ? (
              <a
                href={subcategory.url_absolute}
                title=""
                className={classNames(
                  "bg-white rounded-tr-lg rounded-bl-lg min-h-260px lg:min-h-320px flex flex-col h-full p-4 text-center",
                  {
                    "border border-gray-1100 hover:shadow-mixRedYellow":
                      websiteName !== "bricostore",
                    "shadow-raised sm:hover:shadow-raised-hover":
                      websiteName === "bricostore",
                  }
                )}
              >
                {subcategory.thumbnail && (
                  <img
                    src={resizeImage(subcategory.thumbnail, "300x300")}
                    className="flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10"
                    alt={subcategory.seo_alt_text || subcategory.name}
                  />
                )}
                <Heading
                  as="h2"
                  display="h4"
                  title={subcategory.name}
                  classesProp="break-words mt-5 text-[22px] leading-20 -tracking-0.36"
                />
              </a>
            ) : (
              <Link href={`${baseUrl}/${subcategory.url_key}/cpl/`}>
                <a
                  className={classNames(
                    "bg-white rounded-tr-lg rounded-bl-lg min-h-260px lg:min-h-320px flex flex-col h-full p-4 text-center",
                    {
                      "border border-gray-1100 hover:shadow-mixRedYellow":
                        websiteName !== "bricostore",
                      "shadow-raised sm:hover:shadow-raised-hover":
                        websiteName === "bricostore",
                    }
                  )}
                >
                  {subcategory.thumbnail && (
                    <img
                      src={resizeImage(subcategory.thumbnail, "300x300")}
                      className="flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10"
                      alt={subcategory.seo_alt_text || subcategory.name}
                    />
                  )}
                  <Heading
                    as="h2"
                    display="h4"
                    title={subcategory.name}
                    classesProp="break-words mt-5 text-[22px] leading-20 -tracking-0.36"
                  />
                </a>
              </Link>
            )}
          </li>
        ))}
      </ul>
    );
  }

  return (
    <Alert type="info" showIcon>
      Nu exista subcategorii
    </Alert>
  );
};
export default Subcategories;
